// @ts-nocheck
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { secondsToDisplayTime } from 'common/support/stringHelper';
import ProgressBar from 'components/common/ProgressBar';

import styles from './PlaybackTimeline.module.scss';

const PlaybackTimeline = ({
  durationInSeconds,
  progressInSeconds,
  className,
  cuePoints,
}) => {
  const value = progressInSeconds / durationInSeconds;
  const filteredCuePoints = useMemo(() => cuePoints.filter(time => time > 0), [
    cuePoints,
  ]);

  return (
    <div
      className={classNames('d-flex', styles.wrapper, className)}
      data-testid="playback-timeline"
    >
      <div className={classNames('text-nowrap', 'd-flex', styles.progress)}>
        {secondsToDisplayTime(progressInSeconds)}
      </div>

      <div className="flex-grow-1 position-relative">
        <ProgressBar
          className={classNames(styles.bar, 'w-100')}
          fillerClassName={styles.filler}
          value={value || 0}
        />
        {filteredCuePoints.map(time => (
          <div
            className={classNames(
              'position-absolute',
              'h-100',
              styles.cuePoint,
            )}
            key={time}
            style={{ left: `${(time / durationInSeconds) * 100}%` }}
          />
        ))}
      </div>
      <div
        className={classNames(
          'text-nowrap',
          'd-flex',
          'justify-content-end',
          styles.timeRemaining,
        )}
      >
        {`-${secondsToDisplayTime(durationInSeconds - progressInSeconds)}`}
      </div>
    </div>
  );
};

PlaybackTimeline.propTypes = {
  className: PropTypes.string,
  durationInSeconds: PropTypes.number,
  progressInSeconds: PropTypes.number,
  cuePoints: PropTypes.arrayOf(PropTypes.number),
};

PlaybackTimeline.defaultProps = {
  className: null,
  durationInSeconds: 0,
  progressInSeconds: 0,
  cuePoints: [],
};

export default PlaybackTimeline;
